import { render, staticRenderFns } from "./AccProductReactionListHeader.vue?vue&type=template&id=85f7ef56"
import script from "./AccProductReactionListHeader.vue?vue&type=script&lang=js"
export * from "./AccProductReactionListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports